import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  Chip,
  Paper,
  Stack,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CallSummary from "./CallSummary";
import VoiceConversation from "./VoiceConvorsation";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CallIcon from "@mui/icons-material/Call";
import InfoIcon from "@mui/icons-material/Info";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";
import { jwtDecode } from "jwt-decode";

const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const positiveBg = colorTheme("palette", "positiveBg").value;
const negative = colorTheme("palette", "negative").value;
const negativeBg = colorTheme("palette", "negativeBg").value;
const neutral = colorTheme("palette", "neutral").value;
const neutralBg = colorTheme("palette", "neutralBg").value;

const CallSummaryCss = {
  display: "flex",
  justifyContent: "space-between",
};

const ScoreCardCss = {
  p: 1.5,
  mt: 3,
  borderRadius: 3,
  display: "flex",
  justifyContent: "space-between",
  bgcolor: "#f9fafb",
  border: "1px solid #e5e7eb",
};

const CallDetails = ({
  overview,
  data,
  customerAnalytics,
  agentAnalytics,
  transcript,
  setValue,
  onReTranscribe,
  isReTranscribing,
}) => {
  const [expandedIndex, setExpandedIndex] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [transcriptionService, setTranscriptionService] = useState("deepgram");
  const handleChange = (index) => (event, isExpanded) => {
    setExpandedIndex(isExpanded ? index : null);
  };
  console.log(data, "data");


  const COMPANIES_WITH_SCORING = [
    "mPokket",
    "1Finance",
    "Auric",
    "VTrans",
    "Roposo",
    "vxpressnmc",
    "EBMS Business (India)", "Expert Plus", "Positive Zone", "EBMS Business – RAKEZ Free Zone"
  ];
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : {};
  const showScoringFeatures = COMPANIES_WITH_SCORING.includes(
    decodedToken?.companyName
  );
  const isMPokket = decodedToken?.companyName === "mPokket";
  const isVtrans = decodedToken?.companyName === "VTrans";
  const isCurator = decodedToken?.userRole === "Curator";
  const process = decodedToken?.processType

  console?.log(data?.conversionRate, "from overviewpage");

  const getTextColor = (quality) => {
    switch (quality?.toLowerCase()) {
      case "poor":
        return "black";
      case "average":
        return "black";
      case "good":
        return "black";
      case "excellent":
        return "black";
      default:
        return "inherit";
    }
  };
  const getBgColor = (quality) => {
    switch (quality?.toLowerCase()) {
      case "poor":
        return negativeBg;
      case "average":
        return neutralBg;
      case "good":
        return primaryBg;
      case "excellent":
        return positiveBg;
      default:
        return "inherit";
    }
  };
  return (
    <Grid container spacing={2} mt={2}>
      <Grid
        item
        xs={12}
        md={4}
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        <Grid item xs={12} md={12} sx={{ flex: 1 }}>
          <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
            <Stack
              direction="row"
              spacing={1}
              justifyContent="space-between"
              mb={2}
              flexDirection={{ xs: "column", sm: "row", md: "row" }}
            >
              {" "}
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",

                    backgroundColor: primary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 900,
                  }}
                >
                  <CallIcon
                    sx={{ color: "white", fontWeight: 900, fontSize: 17 }}
                  />
                </Box>
                <Typography
                  variant="h6"
                  fontWeight={500}
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  Call Details
                  <Tooltip
                    title="Here are the basic details associated with the calls."
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <InfoIcon
                      sx={{
                        fontSize: 18,
                        color: "grey",
                      }}
                    />
                  </Tooltip>
                </Typography>
              </Box>
              {/* <Rating
                name="read-only"
                value={Number(overview?.CallRating) || 0}
                readOnly
              />{" "} */}
            </Stack>
            <Grid container spacing={3}>
              {/* <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="gray">
                  Duration
                </Typography>
                <Typography fontWeight="bold">
                  {overview?.CallDuration || "NA"}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="gray">
                  Date/Time
                </Typography>
                <Typography fontWeight="bold">
                  {data?.createdAt || "NA"}
                </Typography>
              </Grid> */}

              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="gray">
                  Agent
                </Typography>
                <Typography fontWeight="bold">
                  {" "}
                  {overview?.AgentName || "NA"}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="gray">
                  Customer
                </Typography>
                <Typography fontWeight="bold" sx={{}}>
                  {overview?.CustomerName?.toLowerCase()
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ") || " NA"}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="gray">
                  Call Intent
                </Typography>
                <Chip
                  label={overview?.CallIntent || "NA"}
                  size="small"
                  sx={{
                    mt: 1,
                    backgroundColor: neutralBg,
                    color: "black",
                    // color: "#856404"
                    fontWeight: 500,
                  }}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="gray">
                  Conversion Status
                </Typography>
                <Chip
                  label={(() => {
                    const rate = Number(data?.conversionRate);

                    if (rate === 100) return "Converted";
                    if (rate >= 60) return "Partially Converted";
                    if (rate >= 0) return "Not Converted";
                    return "N/A";
                  })()}
                  size="small"
                  sx={{
                    mt: 1,
                    backgroundColor: (() => {
                      const rate = Number(data?.conversionRate);

                      if (rate === 100) return "#C8E6C9"; // ✅ green - Converted
                      if (rate >= 60) return "#FFF3CD"; // 🟡 yellow - Partially Converted
                      if (rate >= 0) return "#F8D7DA"; // 🔴 red - Not Converted
                      return "#E0E0E0"; // default gray (N/A)
                    })(),
                    color: "black",
                    fontWeight: 500,
                  }}
                />
              </Grid> */}
              {process === "sales" && (
                // ------------- SHOW CONVERSION STATUS -------------
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="gray">
                    Conversion Status
                  </Typography>

                  <Chip
                    label={(() => {
                      const rate = Number(data?.conversionRate);

                      if (rate === 100) return "Converted";
                      if (rate >= 60) return "Partially Converted";
                      if (rate >= 0) return "Not Converted";
                      return "N/A";
                    })()}
                    size="small"
                    sx={{
                      mt: 1,
                      backgroundColor: (() => {
                        const rate = Number(data?.conversionRate);

                        if (rate === 100) return "#C8E6C9"; // green - Converted
                        if (rate >= 60) return "#FFF3CD"; // yellow - Partially Converted
                        if (rate >= 0) return "#F8D7DA"; // red - Not Converted
                        return "#E0E0E0"; // default gray
                      })(),
                      color: "black",
                      fontWeight: 500,
                    }}
                  />
                </Grid>
              )}
              {process === "support" && (
                // ------------- SHOW RECOVERY STATUS -------------
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="gray">
                    Resolution status
                  </Typography>

                  {/* <Chip
                    label={data?.RecoveryStatus || "N/A"}
                    size="small"
                    sx={{
                      mt: 1,
                      backgroundColor: "#E0E0E0",
                      color: "black",
                      fontWeight: 500,
                    }}
                  /> */}
                  <Chip
                    label={(() => {
                      const rate = data?.conversionRate;
                      if (rate == 100) return "Resolved";
                      if (rate >= 60) return "Partially Resolved";
                      if (rate >= 0) return "Not Resolved";
                      return "N/A";
                    })()}
                    size="small"
                    sx={{
                      mt: 1,
                      backgroundColor:
                        data?.conversionRate >= 70
                          ? "#C8E6C9"
                          : data?.conversionRate >= 40
                            ? "#FFF3CD"
                            : "#F8D7DA",
                      color: "black",
                      fontWeight: 500,
                    }}
                  />
                </Grid>
              )}

              {/* call outcome  */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" color="gray">
                  Call Outcome
                </Typography>
                <Chip
                  label={overview?.CallOutcome || "NA"}
                  size="small"
                  sx={{
                    mt: 1,
                    backgroundColor: neutralBg,
                    color: "black",
                    fontWeight: 500,
                  }}
                />
              </Grid>

              {/* Lead Potential */}
              {process === "sales" && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="gray">
                    Lead Potential
                  </Typography>
                  <Chip
                    label={(() => {
                      const rate = data?.conversionRate;
                      if (rate >= 70) return "High Potential";
                      if (rate >= 40) return "Medium Potential";
                      if (rate >= 0) return "Low Potential";
                      return "N/A";
                    })()}
                    size="small"
                    sx={{
                      mt: 1,
                      backgroundColor:
                        data?.conversionRate >= 70
                          ? "#C8E6C9"
                          : data?.conversionRate >= 40
                            ? "#FFF3CD"
                            : "#F8D7DA",
                      color: "black",
                      fontWeight: 500,
                    }}
                  />
                </Grid>
              )}
              {/* Lead Potential */}
              {process === "recovery" && (
                <Grid item xs={12} sm={6}>
                  <Typography variant="body2" color="gray">
                    Recovery Probability
                  </Typography>
                  <Chip
                    label={(() => {
                      const rate = data?.RecoveryRate;
                      if (rate >= 70) return "High";
                      if (rate >= 40) return "Moderate";
                      if (rate >= 0) return "Low";
                      return "N/A";
                    })()}
                    size="small"
                    sx={{
                      mt: 1,
                      backgroundColor:
                        data?.conversionRate >= 70
                          ? "#C8E6C9"
                          : data?.conversionRate >= 40
                            ? "#FFF3CD"
                            : "#F8D7DA",
                      color: "black",
                      fontWeight: 500,
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12} md={12} sx={{ flex: 1 }}>
          <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
            <Stack direction="row" spacing={1} alignItems="center" mb={2}>
              <Typography variant="h6" fontWeight={500}>
                Scoring Card Snapshot
              </Typography>
              <Tooltip
                title="Gives an overview about how agent did on the call"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 18,
                    color: "grey",
                  }}
                />
              </Tooltip>
            </Stack>
            <Grid container spacing={2}>
              {/* Call Quality */}
              {/* <Grid item xs={4}>
                <Box
                  sx={{
                    borderRadius: 2,
                    p: 1,
                    textAlign: "center",
                    bgcolor: neutralBg,
                    border: "1px solid #e5e7eb",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, fontWeight: "bold", color: "#9ca3af" }}
                  >
                    Call Quality
                  </Typography>
                  <Typography
                    variant="h6"
                    fontWeight="medium"
                    sx={{ color: "black" }}
                  >
                    {overview?.CallQualityGrade || "NA"}
                  </Typography>
                </Box>
              </Grid> */}

              {/* Conversion Rate */}

              {/* <Grid item xs={4}>
                <Box
                  sx={{
                    bgcolor: "#DCFCE7",
                    border: "1px solid #e5e7eb",
                    borderRadius: 2,
                    p: 1,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      mb: 1,
                      fontWeight: "bold",
                      color: "#9ca3af",
                      whiteSpace: "wrap",
                    }}
                  >
                    Conversion Rate
                  </Typography>
                  <Typography variant="h6" fontWeight="medium">
                    {/* {data?.conversionRate < 0 || data?.conversionRate > 100 ? 'N/A'
                      : data?.conversionRate < 75 ? 'Medium'
                        : 'High'} */}
              {/* {`${data?.conversionRate ?? 0}%`}
                  </Typography>
                </Box>
              </Grid> */}

              {/* Call Compliance */}
              {/* <Grid item xs={4}>
                <Box
                  sx={{
                    bgcolor: neutralBg,
                    border: "1px solid #e5e7eb",
                    borderRadius: 2,
                    p: 1,
                    textAlign: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ mb: 1, fontWeight: "bold", color: "#9ca3af" }}
                  >
                    Compliance
                  </Typography>
                  <Typography variant="h6" fontWeight="medium">
                    {overview?.ComplianceStatus ? "Pass" : "Fail"}
                  </Typography>
                </Box>
              </Grid> */}

              <Grid container spacing={2}>
                {/* Call Quality */}
                <Grid item xs={4}>
                  <Box
                    sx={{
                      borderRadius: 2,
                      p: 1,
                      textAlign: "center",
                      bgcolor: neutralBg,
                      border: "1px solid #e5e7eb",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, fontWeight: "bold", color: "#9ca3af" }}
                    >
                      {showScoringFeatures ? "Call Score" : "Call Quality"}
                    </Typography>

                    <Typography
                      variant="h6"
                      fontWeight="medium"
                      sx={{ color: "black" }}
                    >
                      {showScoringFeatures
                        ? `${data?.callScore ?? "NA"}%`
                        : overview?.CallQualityGrade || "NA"}
                    </Typography>
                  </Box>
                </Grid>

                {/* Conversion Rate — hide for mPokket */}
                {process === "sales" && (
                  <Grid item xs={4}>
                    <Box
                      sx={{
                        bgcolor: "#DCFCE7",
                        border: "1px solid #e5e7eb",
                        borderRadius: 2,
                        p: 1,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontWeight: "bold",
                          color: "#9ca3af",
                          whiteSpace: "wrap",
                        }}
                      >
                        Conversion Rate
                      </Typography>

                      <Typography variant="h6" fontWeight="medium">
                        {`${data?.conversionRate ?? 0}%`}
                      </Typography>
                    </Box>
                  </Grid>
                )}
                {process === "support" && (
                  <Grid item xs={4}>
                    <Box
                      sx={{
                        bgcolor: "#DCFCE7",
                        border: "1px solid #e5e7eb",
                        borderRadius: 2,
                        p: 1,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontWeight: "bold",
                          color: "#9ca3af",
                          whiteSpace: "wrap",
                        }}
                      >
                        Resolution Rate
                      </Typography>

                      <Typography variant="h6" fontWeight="medium">
                        {`${data?.conversionRate ?? 0}%`}
                      </Typography>
                    </Box>
                  </Grid>
                )}
                {/* {process === "recovery" && (
                  <Grid item xs={4}>
                    <Box
                      sx={{
                        bgcolor: "#DCFCE7",
                        border: "1px solid #e5e7eb",
                        borderRadius: 2,
                        p: 1,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          mb: 1,
                          fontWeight: "bold",
                          color: "#9ca3af",
                          whiteSpace: "wrap",
                        }}
                      >
                        Recovery Rate
                      </Typography>

                      <Typography variant="h6" fontWeight="medium">
                        {`${data?.RecoveryRate ?? 0}%`}
                      </Typography>
                    </Box>
                  </Grid>
                )} */}

                {/* Compliance — hide for mPokket */}
                {/* {!isMPokket && ( */}
                <Grid item xs={4}>
                  <Box
                    sx={{
                      bgcolor: neutralBg,
                      border: "1px solid #e5e7eb",
                      borderRadius: 2,
                      p: 1,
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, fontWeight: "bold", color: "#9ca3af" }}
                    >
                      Compliance
                    </Typography>

                    <Typography variant="h6" fontWeight="medium">
                      {overview?.ComplianceStatus ? "Pass" : "Fail"}
                    </Typography>
                  </Box>
                </Grid>
                {/* )} */}
              </Grid>

              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={1}
                >
                  <Typography variant="body2">
                    Overall Compliance Accuracy
                  </Typography>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {`${overview?.CallAdherence?.pass}%` || "NA"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {/* <Typography variant="body2">Coaching Required</Typography>
                  {overview?.CallAdherence?.pass >= 75 ? (
                    <Chip
                      label="No"
                      size="small"
                      sx={{
                        backgroundColor: positiveBg,
                        px: 1,
                        py: 1,
                        borderRadius: "5px",
                        fontSize: 12,

                        color: "black",
                      }}
                    />
                  ) : (
                    <Chip
                      label="Yes"
                      size="small"
                      sx={{
                        backgroundColor: negativeBg,

                        color: "black",
                        px: 1.5,
                        py: 0.8,
                        borderRadius: "4px",
                        fontSize: 12,
                      }}
                    />
                  )} */}

                  {/* {overview?.CoachingRequired == false ? (
                    <Chip
                      label="No"
                      icon={<CancelIcon color="#2e7044" size={12} />}
                      size="small"
                      sx={{
                        backgroundColor: "#DCFCE7",
                        px: 1,
                        py: 1,
                        borderRadius: "5px",
                        fontSize: 12,
                        color: "#2e7044",
                      }}
                    />
                  ) : (
                    <Chip
                      label="Yes"
                      icon={<CheckCircleIcon color="#9c2e42" size={12} />}
                      size="small"
                      sx={{
                        backgroundColor: "#FEE2E2",
                        color: "#9c2e42",
                        px: 1.5,
                        py: 0.8,
                        borderRadius: "4px",
                        fontSize: 12,
                      }}
                    />
                  )} */}
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        md={8}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Paper elevation={1} sx={{ flex: 1, p: 2, borderRadius: 2 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="h6" fontWeight={500}>
                Call Playback with Transcript & Sentiment Analysis
              </Typography>
              <Tooltip
                // title="Gives the transcript of the conversation along with the bifurcation between the agent and customer with the audio file being played."
                title="Gives the transcript of the conversation (with agent/customer split) alongside real-time sentiment analysis while the audio plays."
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 18,
                    color: "grey",
                  }}
                />
              </Tooltip>
            </Stack>
            {isCurator && (
              <Tooltip title={isReTranscribing ? "Re-transcription in progress…" : "Re-Transcribe & Re-Diarize"}>
                <span>
                  <IconButton
                    onClick={() => setConfirmOpen(true)}
                    disabled={isReTranscribing}
                    size="small"
                    sx={{
                      color: isReTranscribing ? "grey.400" : "#7635DD",
                      "@keyframes spin": {
                        "0%": { transform: "rotate(0deg)" },
                        "100%": { transform: "rotate(360deg)" },
                      },
                      animation: isReTranscribing ? "spin 1.2s linear infinite" : "none",
                      "&:hover": { bgcolor: "rgba(118, 53, 221, 0.08)" },
                    }}
                  >
                    <AutorenewIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            )}
          </Stack>

          <VoiceConversation
            transcript={transcript}
            customerAnalytics={customerAnalytics}
            isReTranscribing={isReTranscribing}
          />
        </Paper>

        <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Re-Transcribe Recording?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              This will re-process the audio and overwrite the existing transcript, diarization, and analysis data. This may take a few minutes.
            </DialogContentText>
            {isMPokket && (
              <FormControl sx={{ mt: 2 }}>
                <FormLabel sx={{ fontSize: 13, fontWeight: 600 }}>Transcription Service</FormLabel>
                <RadioGroup
                  row
                  value={transcriptionService}
                  onChange={(e) => setTranscriptionService(e.target.value)}
                >
                  <FormControlLabel value="deepgram" control={<Radio size="small" />} label="Deepgram" />
                  <FormControlLabel value="azure" control={<Radio size="small" />} label="Azure" />
                  <FormControlLabel value="azure-mai" control={<Radio size="small" />} label="Azure MAI" />
                  <FormControlLabel value="sarvam" control={<Radio size="small" />} label="Sarvam AI" />
                  <FormControlLabel value="speechmatics" control={<Radio size="small" />} label="Speechmatics" />
                  <FormControlLabel value="elevenlabs" control={<Radio size="small" />} label="ElevenLabs" />
                </RadioGroup>
              </FormControl>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
            <Button
              onClick={() => { setConfirmOpen(false); onReTranscribe && onReTranscribe(isMPokket ? transcriptionService : undefined); }}
              variant="contained"
              sx={{ bgcolor: "#7635DD", "&:hover": { bgcolor: "#5f2bb3" } }}
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        {isMPokket && (
          <Grid item xs={12} md={12} sx={{ flex: 1 }}>
            <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mt: 2 }}>
              <Stack direction="row" spacing={1} alignItems="center" mb={2}>
                <Typography variant="h6" fontWeight={500}>
                  Detailed Analysis
                </Typography>
                <Tooltip
                  title="Key observations on the agent from quality perspective."
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <InfoIcon
                    sx={{
                      fontSize: 18,
                      color: "grey",
                    }}
                  />
                </Tooltip>
              </Stack>
              <Stack spacing={1} mt={2}>
                {overview?.moments?.length > 0 ? (
                  overview?.moments?.map((e, i) => {
                    const key = e ? Object.keys(e)[0] : "";
                    return (
                      <>
                        <Typography
                          component="span"
                          sx={{
                            fontSize: 14,
                            fontWeight: 600,
                            "::before": {
                              content: '"•"',
                              position: "absolute",
                              left: 0,
                              color: "",
                              fontWeight: "bold",
                            },
                          }}
                        >
                          {key?.replace(/([a-z])([A-Z])/g, "$1 $2") || "-"}
                        </Typography>
                        <Accordion
                          expanded={expandedIndex === i}
                          onChange={handleChange(i)}
                          sx={{
                            // backgroundColor: "#F3EFFF",
                            boxShadow: "none",
                            border: "0.1px solid #ddd",
                            mb: 1,
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            <Typography
                              component="span"
                              sx={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: "grey",
                              }}
                            >
                              {/* <span
                                style={{
                                  color:"000",
                                  fontWeight: 700,
                                }}
                              >
                                Title:
                              </span>{" "} */}
                              {e?.[key]?.section || "NA"}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            {/* <Typography
                              sx={{
                                color: "rgb(65, 65, 65)",
                                fontSize: "0.9rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                                mb: 1,
                              }}
                            >
                              <span
                                style={{
                                  color: "grey",
                                  fontWeight: 700,
                                }}
                              >
                                Title:
                              </span>{" "}
                              {e?.[key]?.section || ""}
                            </Typography> */}
                            <Typography
                              sx={{
                                color: "rgb(65, 65, 65)",
                                fontSize: "0.9rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                                mb: 1,
                              }}
                            >
                              <span
                                style={{
                                  color: "grey",
                                  fontWeight: 700,
                                }}
                              >
                                Theme:
                              </span>{" "}
                              {e?.[key]?.theme || "NA"}
                            </Typography>
                            <Typography
                              sx={{
                                color: "rgb(65, 65, 65)",
                                fontSize: "0.9rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                              }}
                            >
                              <span
                                style={{
                                  color: "grey",
                                  fontWeight: 700,
                                }}
                              >
                                Quote:
                              </span>{" "}
                              {e?.[key]?.quote || "NA"}
                            </Typography>
                            <Typography
                              sx={{
                                color: "rgb(65, 65, 65)",
                                fontSize: "0.9rem",
                                fontFamily:
                                  "Roboto, Helvetica, Arial, sans-serif",
                                // fontWeight: 600,
                                mt: 1,
                              }}
                            >
                              <span
                                style={{
                                  color: "grey",
                                  fontWeight: 600,
                                }}
                              >
                                Explanation :
                              </span>{" "}
                              {e?.[key]?.explanation || "NA"}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      </>
                    );
                  })
                ) : (
                  <Chip
                    label="No Data Available"
                    size="small"
                    sx={{
                      backgroundColor: "#E4E5E7",
                      color: "#5F6062",
                      fontWeight: 500,
                      px: 1.5,
                      py: 0.5,
                      borderRadius: "4px",
                    }}
                  />
                )}
              </Stack>
            </Paper>
          </Grid>
        )}
        {/* <Grid item xs={12} md={12} sx={{ flex: 1 }}>
          <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mt: 2 }}>
            <Stack direction="row" spacing={1} alignItems="center" mb={2}>
              <Typography variant="h6" fontWeight={500} mb={2}>
                Flags & Alerts
              </Typography>
              <Tooltip
                title="Gives the alert or trigger points which required immidiate action."
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 18,
                    color: "grey",
                  }}
                />
              </Tooltip>
            </Stack>
            <Stack spacing={1}>
              <Box
                sx={{
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  p: 1,
                  gap: 1,
                   border: "1px solid #e5e7eb",
                   backgroundColor: "#FFF7D6",
                  justifyContent: "space-between",
                }}
              >
                <Typography>
                  {" "}
                  <FlagIcon
                    sx={{
                      color: "#ffa061",
                      fontSize: 16,
                      mr: 0.6,
                    }}
                    size={12}
                  />
                  Escalation Flag
                </Typography>
                <Typography variant="body2">
                  {overview?.FlagsAndAlerts?.EscalationFlag}
                </Typography>
              </Box>

              <Box
                sx={{
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  p: 1,
                  gap: 1,
                   backgroundColor: "#FFE4E4",
                  justifyContent: "space-between",
                }}
              >
                <Typography>
                  {" "}
                  <WarningIcon
                    sx={{
                      color: "red",
                      fontSize: 16,
                      mr: 0.6,
                    }}
                    size={12}
                  />
                  Repeat Complaint
                </Typography>
                <Typography variant="body2">
                  {overview?.FlagsAndAlerts?.RepeatComplaint}
                </Typography>
              </Box>
              <Box
                sx={{
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  p: 1,
                  gap: 1,
                   backgroundColor: "#DBEAFE",
                  justifyContent: "space-between",
                }}
              >
                <Typography>
                  <SyncIcon
                    sx={{
                      color: "#b3b3b3",
                      fontSize: 16,
                      mr: 0.6,
                    }}
                    size={12}
                  />{" "}
                  Reopened Call
                </Typography>
                <Typography variant="body2">
                  {overview?.FlagsAndAlerts?.ReopenedCall}
                </Typography>
              </Box>
              <Box
                sx={{
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 1,
                  gap: 1,
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Typography>
                  {" "}
                  <ErrorIcon
                    sx={{
                      color: "#b3b3b3",
                      fontSize: 16,
                      mr: 0.6,
                    }}
                    size={12}
                  />
                  Compliance Violation
                </Typography>
                <Typography variant="body2">
                  {overview?.FlagsAndAlerts?.ComplianceViolation}
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Grid> */}
      </Grid>

      <Grid
        item
        xs={12}
        md={8}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <CallSummary data={data} overview={overview} setValue={setValue} />
      </Grid>
    </Grid>
  );
};

export default CallDetails;
